import { memo } from 'react';
import { components } from 'react-select';
import { SingleValueCountryProps } from './types';
import s from './index.module.scss';

export const SingleValueCountry = memo(function SingleValueCountry(props: SingleValueCountryProps) {
  const { data: country } = props;
  return (
    <components.SingleValue {...props}>
      <div className={s.value}>
        <div className={s.flag}>
          <img src={country.flag} alt={country.label} />
        </div>
        <div className={s.name}>{country.label}</div>
      </div>
    </components.SingleValue>
  );
});